import { css } from "@emotion/react";
import { BtnNext, BtnPrev } from "assets/desktop/images/member-vip";

export const SwiperVipDetailsStyle = {
  wrapper: css`
    width: 450px !important;
  `,
  buttonSwiper: css`
    width: 650px;
    position: absolute;
    z-index: 9;
    top: 90px;

    display: flex;
    align-items: center;
    justify-content: space-between;
  `,

  btn: css`
    background-image: url(${BtnPrev});
    &:nth-of-type(2) {
      background-image: url(${BtnNext});
    }
    cursor: pointer;

    background-repeat: no-repeat;
    background-position: top;
    height: 34px;
    width: 24px;
    &:hover {
      background-position: bottom;
    }
  `,
};
